import React, { useEffect, useState } from 'react';
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_kratos";
import useHttp from "../../../hook/use-http";
import ChartLoader from "./ChartLoader";
import WaterMark from "../DashboardMain_Kratos/WaterMark";
import NoTableData from "./NoTableData";
import NoData from './NoData';
import { useNavigate } from "react-router-dom";
import './CriticalCustom_Kratos_fleet.css';
import DataTable from 'react-data-table-component';

export default function CriticalTitleWiseTable({ gloablfilter }) {

  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [criticalTableData, setCriticalTableData] = useState([]);
  const [titleTableData, setTitleTableData] = useState([]);
  const [TBSelected, setTBSelected] = useState('A');
  // const [TitleSelected, setTitleSelected] = useState('_SOH');
  const [TitleSelected, setTitleSelected] = useState('total_soc_duration');
  const [dataValue, setDataValue] = useState('A_SOH_Value');
  // const [columnValue, setColumnValue] = useState('SOH(%)');
  const [columnValue, setColumnValue] = useState('Duration(Min)');

  const navigate = useNavigate();
  const handleRowClick = (vehicleId) => {
    // navigate(`/dashboard_kratos/rca_kratos/${vehicleId}`);
  };

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "critical_vehicles_kratos_fleet/highest_Temp_vehicles", body: { filterdata: gloablfilter, packType: TBSelected } }, critical_response)
  }, [gloablfilter])

  useEffect(() => {
    if (TitleSelected === '_SOH' || TitleSelected === '_SOC') {
      fetchData({ url: API_URL_MAIN + "critical_vehicles_kratos_fleet/lowest_SOC_SOH_vehicles", body: { filterdata: gloablfilter, packType: TBSelected + TitleSelected } }, title_response)
    }
    else if (TitleSelected === 'total_duration' || TitleSelected === 'total_soc_duration') {
      fetchData({ url: API_URL_MAIN + "critical_vehicles_kratos_fleet/highest_SOC_current_imbalance", body: { filterdata: gloablfilter, imbalanceType: TitleSelected } }, title_response)
    }
  }, [gloablfilter, TitleSelected, TBSelected])

  const critical_response = (data) => {
    setCriticalTableData(data);
  }

  const title_response = (data) => {
    setTitleTableData(data);
  }

  const changeTB = (selectOp) => {
    setCriticalTableData([]);
    // setTitleSelected([])
    setTitleTableData([])
    setTBSelected(selectOp);
  }

  const [columns, setcolumns] = useState([
    // {name: 'Vin',selector: (row) => row.key.vehicleId,width: '30%',center: true, sortable: true},
    {
      name: 'Vin',
      // selector: (row) => row.key.vehicleId,width: '30%',
      selector: (row) => (
        <div onClick={() => handleRowClick(row.key.vehicleId)} style={{ cursor: 'pointer' }}>
          {row.key.vehicleId}
        </div>
      ),
      width: '28%',
      center: true,
    },
    { name: 'Reg No.', selector: (row) => row.key.vehicle_registration_number, width: '19%', center: true, sortable: true },
    { name: 'City', selector: (row) => row.key.DLR_ORG_CITY, width: '18%', sortable: true, center: true },
    { name: 'Depot', selector: (row) => row.key.Depot_Name, width: '20%', center: true, sortable: true },
    {
      name: columnValue,
      selector: (row) => (TitleSelected === '_SOH' || TitleSelected === '_SOC') ? row[/* TBSelected + */ TitleSelected?.replace("_","") + '_Value'].value.toFixed(2) : row[TitleSelected].value.toFixed(2),
      width: '15%',
      center: true,
      sortable: true
    }
  ]);
  const changeTitle = (selectTitle) => {
    setTitleTableData([])
    setTitleSelected(selectTitle);
    if (selectTitle === '_SOH') {
      setColumnValue("SOH(%)")
    } else if (selectTitle === '_SOC') {
      setColumnValue("SOC(%)")
    } else if (selectTitle === 'total_duration') {
      setColumnValue("Duration(Min)")
    } else {
      setColumnValue("Duration(Min)")
    }
    // fetchData({ url: API_URL_MAIN + "critical_vehicles_bus/" + extraThings["apiEndPoint"], body: { filterdata: gloablfilter, packType: selectOp + extraThings["withDropdown"] } }, critical_response)
  }

  // const columns = [
  //   // {name: 'Vin',selector: (row) => row.key.vehicleId,width: '30%',center: true, sortable: true},
  //   {
  //     name: 'Vin',
  //     // selector: (row) => row.key.vehicleId,width: '30%',
  //     selector: (row) => (
  //       <div onClick={() => handleRowClick(row.key.vehicleId)} style={{ cursor: 'pointer' }}>
  //         {row.key.vehicleId}
  //       </div>
  //     ),
  //     width: '28%',
  //     center: true,
  //   },
  //   { name: 'Reg No.', selector: (row) => row.key.vehicle_registration_number, width: '19%', center: true, sortable: true },
  //   { name: 'City', selector: (row) => row.key.DLR_ORG_CITY, width: '18%', sortable: true, center: true },
  //   { name: 'Depot', selector: (row) => row.key.Depot_Name, width: '20%', center: true, sortable: true },
  //   {
  //     name: columnValue,
  //     selector: (row) => (TitleSelected === '_SOH' || TitleSelected === '_SOC') ? row[TBSelected + TitleSelected + '_Value'].value.toFixed(2) : row[TitleSelected].value.toFixed(2),
  //     width: '15%',
  //     center: true,
  //     sortable: true
  //   }
  // ];

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#83A4CF',
        color: '#fff',
        fontWeight: 'bold',
        fontSize: '11px',
      },
    },
    rows: {
      style: {
        fontSize: '11px', // Custom font size for data rows
        // height: '25px',
        minHeight: '35px'
      },
    },
    headRow: {
      style: {
        minHeight: '40px',
      },
    },
  };

  const conditionalRowStyles = [
    {
      when: (row) => {
        return row.index % 2 === 0;
      },
      style: {
        backgroundColor: '#fff',
      },
    },
  ];

  useEffect(() => {
    if (TitleSelected === "_SOH") {
      setcolumns([])
      setcolumns(
        [
          // {name: 'Vin',selector: (row) => row.key.vehicleId,width: '30%',center: true, sortable: true},
          {
            name: 'Vin',
            // selector: (row) => row.key.vehicleId,width: '30%',
            selector: (row) => (
              <div onClick={() => handleRowClick(row.key.vehicleId)} style={{ cursor: 'pointer' }}>
                {row.key.vehicleId}
              </div>
            ),
            width: '25%',
            center: true,
          },
          { name: 'Reg No.', selector: (row) => row.key.vehicle_registration_number, width: '', center: true, sortable: true },
          { name: 'City', selector: (row) => row.key.DLR_ORG_CITY, width: '', sortable: true, center: true },
          { name: 'Depot', selector: (row) => row.key.Depot_Name, width: '', center: true, sortable: true },
          {
            name: columnValue,
            selector: (row) => (TitleSelected === '_SOH' || TitleSelected === '_SOC') ? row[/* TBSelected + */ TitleSelected?.replace("_","") + '_Value']?.value.toFixed(2) : row[TitleSelected]?.value.toFixed(2),
            width: '',
            center: true,
            sortable: true
          },
          { name: 'Odo', selector: (row) => row.endOdo.value, width: '', center: true, sortable: true },
        ])
    } else {
      setcolumns([])
      setcolumns([
        // {name: 'Vin',selector: (row) => row.key.vehicleId,width: '30%',center: true, sortable: true},
        {
          name: 'Vin',
          // selector: (row) => row.key.vehicleId,width: '30%',
          selector: (row) => (
            <div onClick={() => handleRowClick(row.key.vehicleId)} style={{ cursor: 'pointer' }}>
              {row.key.vehicleId}
            </div>
          ),
          width: '28%',
          center: true,
        },
        { name: 'Reg No.', selector: (row) => row.key.vehicle_registration_number, width: '19%', center: true, sortable: true },
        { name: 'City', selector: (row) => row.key.DLR_ORG_CITY, width: '18%', sortable: true, center: true },
        { name: 'Depot', selector: (row) => row.key.Depot_Name, width: '20%', center: true, sortable: true },
        {
          name: columnValue,
          selector: (row) => (TitleSelected === '_SOH' || TitleSelected === '_SOC') ? row[/* TBSelected + */ TitleSelected?.replace("_","") + '_Value']?.value.toFixed(2) : row[TitleSelected]?.value.toFixed(2),
          width: '15%',
          center: true,
          sortable: true
        }
      ])
    }
  }, [titleTableData])

  return (
    <>
      {/* <div className="col-lg-12 col-md-6 col-sm-12 mt-3 pr-0"> */}
      <div className="chargingChartboxNew_Kratos">
        <div className="v-title chargingTitleChart_Kratos_fleet">
          <div className="row p-2">
            <div className="col-lg-6 col-md-7 col-sm-7 col-7">
              <select className="form-select form-select-sm" aria-label=".form-select-sm example" style={{ marginBottom: "-5px", marginTop: "-5px" }} onChange={(event) => changeTitle(event.target.value)} value={TitleSelected}>
                <option value="_SOH">20 Lowest SOH (%) vehicles </option>
                <option value="_SOC">20 Lowest SOC (%) vehicles</option>
                <option value="total_duration">20 Highest current imbalance vehicles</option>
                <option value="total_soc_duration">20 Highest SOC imbalance vehicles</option>
              </select>
            </div>
            <div className="col-lg-3 col-md-5 col-sm-5 col-5"></div>
            <div className="col-lg-3 col-md-5 col-sm-5 col-5">
              {/* {(TitleSelected === '_SOH' || TitleSelected === '_SOC') ?
                <select className="form-select form-select-sm" aria-label=".form-select-sm example" style={{ marginBottom: "-5px", marginTop: "-5px" }} onChange={(event) => changeTB(event.target.value)} value={TBSelected}>
                  <option value="A">Pack A</option>
                  <option value="B">Pack B</option>
                  <option value="C">Pack C</option>
                  <option value="D">Pack D</option>
                </select>
                : <></>
              } */}
            </div>
          </div>
        </div>

        <div className="tableContent_Kratos px-2" style={{ height: '248px', position: "sticky" }}>
          <WaterMark />
          {
            (isLoading) ? <ChartLoader /> : (titleTableData.length > 0) ?
              <DataTable
                columns={columns}
                // data={titleTableData}
                data={titleTableData.map((item, index) => ({
                  ...item,
                  index,
                  className: index % 2 === 0 ? 'even-row' : 'odd-row',
                }))}
                customStyles={customStyles}
                fixedHeader={true}
                fixedHeaderScrollHeight="248px"
                conditionalRowStyles={conditionalRowStyles}
              /> :
              <NoData />
          }
        </div>
      </div>
      {/* </div> */}
    </>
  )
}
